<app-toast></app-toast>

<div class="h-screen flex flex-col items-center p-5 mobile:p-2">
    <!-- Top bar-->
    <div class="w-full">
        <app-admin-topbar></app-admin-topbar>
    </div>

    <!-- Tab Navigation -->
    <div class="w-full">
        <app-admin-navigation [isActiveNumber]="AdminSectionId.PROMOTION_CODES"></app-admin-navigation>
    </div>

    <!-- Promotion codes -->
    <div class="w-full h-full border-[1px] border-border rounded-[20px] flex flex-col mt-2">
        <!-- Header text -->
        <div class="flex">
            <div class="flex flex-col gap-4 h-[60px] justify-between">
                <p class="text-primary font-semibold ml-4 mr-4 mt-4 mobile:text-sm">
                    {{ 'admin.promotion_codes' | transloco }}
                </p>
                <div class="h-[2px] w-full bg-primary"></div>
            </div>
            <div class="h-[60px] flex flex-grow items-end justify-start mobile:hidden">
                <div class="h-[2px] w-full bg-border"></div>
            </div>
        </div>

        <!-- Content -->
        <div class="w-full flex flex-col gap-2 p-5">
            <div class="mb-4" *ngIf="isLoading">
                <span class="text-sm text-neutral-500">
                    {{ 'shared.loading' | transloco }}
                </span>
            </div>

            <div
                class="overflow-x-auto max-w-ultrawide justify-center mb-4 mobile:max-w-screen h-full block min-h-[500px] rounded-[16px]">
                <table class="table w-full" *ngIf="promotionCodesList.length; else emptyState">
                    <!-- Header -->
                    <thead class="bg-secondary-100 text-neutral-700 uppercase">
                        <tr class="max-h-[50px]">
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'admin.campaign_name' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'admin.discount_type' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'admin.available_redeemed' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'admin.promo_code' | transloco }}
                            </th>
                            <th class="border-b border-border px-4 py-4 font-normal">
                                {{ 'admin.invite_url' | transloco }}
                            </th>
                        </tr>
                    </thead>

                    <!-- Content -->
                    <tbody>
                        <ng-container *ngFor="let promo of promotionCodesList; let i = index">
                            <tr class="max-h-[50px]">
                                <!-- 1. Campaign name -->
                                <td class="border-b border-border px-4 py-4">
                                    {{ getCampaignName(promo) }}
                                </td>

                                <!-- 2. Type of discount (description) -->
                                <td class="border-b border-border px-4 py-4 text-sm">
                                    {{ getDiscountDescription(promo) }}
                                </td>

                                <!-- 3. Available / Redeemed (e.g. 3/20) -->
                                <td class="border-b border-border px-4 py-4">
                                    {{ getRedemptionInfo(promo) }}
                                </td>

                                <!-- 4. Promo code -->
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 flex-wrap items-center">
                                        <span class="font-mono text-sm">
                                            {{ promo.code }}
                                        </span>
                                        <button title="{{ 'admin.copy' | transloco }}" type="button"
                                            class="p-1 rounded hover:bg-neutral-100" (click)="copyText(promo.code)">
                                            <img src="assets/icons/copy.svg" class="w-[24px] h-[24px]"
                                                alt="{{ 'admin.copy' | transloco }}" />
                                        </button>
                                    </div>
                                </td>

                                <!-- 5. Invite URL -->
                                <td class="border-b border-border px-4 py-4">
                                    <div class="flex gap-2 flex-wrap items-center">
                                        <span class="min-w-[250px]">
                                            {{ generateUrl(promo) }}
                                        </span>
                                        <button title="{{ 'admin.copy' | transloco }}" type="button"
                                            class="p-1 rounded hover:bg-neutral-100"
                                            (click)="copyText(generateUrl(promo))">
                                            <img src="assets/icons/copy.svg" class="w-[24px] h-[24px]"
                                                alt="{{ 'admin.copy' | transloco }}" />
                                        </button>
                                    </div>
                                </td>
                            </tr>
                        </ng-container>
                    </tbody>
                </table>

                <ng-template #emptyState>
                    <div class="w-full h-full flex items-center justify-center text-neutral-400 text-sm">
                        {{ 'admin.no_promotion_codes' | transloco }}
                    </div>
                </ng-template>
            </div>
        </div>
    </div>
</div>